export default __webpack_public_path__ + "static/media/chipsLimited.60b753b6.mp3";